import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PersonalizedIdeasPage.css';

const PERSONALIZED_FORM_URL =
  'https://frontal-firestorm-840.forms.space/get-3-personalized-office-outing-ideas-purt4o';

const PersonalizedIdeasPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });

    const existingScript = document.querySelector(
      'script[data-formspace-personalized-embed]'
    );

    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');

    script.src = 'https://formspace.com/embed.js';
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.dataset.formspacePersonalizedEmbed = 'true';

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <main className="personalized-ideas-page">
      <div className="personalized-ideas-container">
        <Link to="/" className="personalized-ideas-back">
          ← Back to matches
        </Link>

        <section className="personalized-ideas-heading">
          <p className="personalized-ideas-eyebrow">
            Free Personalized Shortlist
          </p>

          <h1>Get 3 personalized ideas for your team.</h1>

          <p>
            Tell us about your team, budget, timing, and goals. We’ll review
            your request and email you three tailored experience ideas.
          </p>
        </section>

        <section className="personalized-ideas-note">
          <div
            className="personalized-ideas-note-icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m12 3 1.35 4.15L17.5 8.5l-4.15 1.35L12 14l-1.35-4.15L6.5 8.5l4.15-1.35L12 3Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <path
                d="m18.5 14 .75 2.25L21.5 17l-2.25.75L18.5 20l-.75-2.25L15.5 17l2.25-.75L18.5 14Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div>
            <h2>Your custom shortlist is free.</h2>

            <p>
              This includes three personalized recommendations. Hands-on
              coordination or full-service planning may be available
              separately.
            </p>
          </div>
        </section>

        <section className="personalized-ideas-form-card">
          <div
            className="personalized-ideas-form-embed"
            data-formspace={PERSONALIZED_FORM_URL}
          />
        </section>
      </div>
    </main>
  );
};

export default PersonalizedIdeasPage;
